import { Trans } from "@lingui/react/macro";
import React from "react";
import {
  PartialSanityImageType,
  Button,
  SectionContainer,
  ButtonsContainer
} from "@silversea-ssc/ui-components-react";
import * as styles from "./Herospace.module.scss";
import NativeHeroImage from "components/NativeHeroImage/NativeHeroImage";
import { RAQButton } from "components/ECommerceButtons";

type HerospaceModel = {
  heroImage: PartialSanityImageType | undefined;
  name: string | undefined;
  title: string | undefined;
  raqPagePath?: string;
};

const Herospace: React.FC<React.PropsWithChildren<HerospaceModel>> = ({
  heroImage,
  name,
  title,
  children,
  raqPagePath
}) => {
  return (
    <div id="hero" className={styles.herospace} data-content-name="hero">
      {heroImage && (
        <NativeHeroImage
          className={styles.backgroundImage}
          image={heroImage}
          alt={name || ""}
        />
      )}
      <div className={styles.contentBox}>
        <SectionContainer backgroundColor="transparent">
          <div className={styles.content}>
            <header className={styles.header}>
              <h1 className={styles.title}>{name}</h1>
              <h2 className={styles.subtitle}>{title}</h2>
            </header>

            <footer className={styles.contentBoxFooter}>
              <ButtonsContainer align="center">
                {raqPagePath && (
                  <RAQButton
                    variant="secondary"
                    url={raqPagePath}
                    size="regular"
                  />
                )}

                <Button
                  renderAs="a"
                  href="#fyc"
                  variant="accent"
                  dataContentPiece="anchor_book_your_cruise_button"
                >
                  <Trans id="ecommerce-button-label">Book your Cruise</Trans>
                </Button>
              </ButtonsContainer>
            </footer>
          </div>
        </SectionContainer>
      </div>
      {children}
    </div>
  );
};

export default Herospace;
